import React from "react";
import useProgress from "../../hooks/useProgress";

const ProgressPage = () => {
  useProgress();

  return <div></div>;
};

export default ProgressPage;
